import { ConnectorType } from '../models/ChargingConnector.ts';

interface ConnectorTypeInfo {
  label: string;
  value: string;
}

export const ConnectorTypeMap: Record<ConnectorType, ConnectorTypeInfo> = {
  CHADEMO: { label: 'CHAdeMO', value: 'CHADEMO' },
  CHAOJI: { label: 'CHAOJI', value: 'CHAOJI' },
  GBT_AC: { label: 'GBT_AC', value: 'GBT_AC' },
  GBT_DC: { label: 'GBT_DC', value: 'GBT_DC' },
  IEC_62196_T1: { label: 'J1772', value: 'IEC_62196_T1' },
  IEC_62196_T2: { label: 'Type 2', value: 'IEC_62196_T2' },
  IEC_62196_T1_COMBO: { label: 'CCS 1', value: 'IEC_62196_T1_COMBO' },
  IEC_62196_T2_COMBO: { label: 'CCS 2', value: 'IEC_62196_T2_COMBO' },
  MCS: { label: 'MCS', value: 'MCS' },
  SAE_J3400: { label: 'NACS (Tesla)', value: 'SAE_J3400' },
};

export const getConnectorTypeLabel = (connectorType: ConnectorType): string => {
  return ConnectorTypeMap[connectorType]?.label || connectorType;
};
